// Module
var code = "<div class=\"alert alert-danger alert-dismissible\" role=\"alert\"> <i class=\"fa fa-warning\"></i> <span class=\"position-relative left-10\">Referred By is a required field when Enquiry Source of Referral is selected.</span> </div> ";
// Exports
module.exports = code;